import { render, staticRenderFns } from "./VolumeList.vue?vue&type=template&id=18d70992"
import script from "./VolumeList.vue?vue&type=script&lang=js"
export * from "./VolumeList.vue?vue&type=script&lang=js"
import style0 from "./VolumeList.vue?vue&type=style&index=0&id=18d70992&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports